import { get } from 'lodash';
import { mapActions, mapState } from 'vuex';
import withdrawConfirm from '@/components/wallet/withdraw-confirm/withdraw-confirm.vue';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import availableBalance from '@/components/wallet/available-balance/available-balance.vue';
import { formMixin, validators } from '@/components/forms/mixin';
import documentUploadMixin from '@/mixins/documentUpload';
import contentLoaderMixin from '@/mixins/contentLoader';
import withdrawWarningMixin from '@/mixins/withdrawWarning';
import { roundDown } from '@/utils/helpers';

export default {
  mixins: [
    contentLoaderMixin,
    documentUploadMixin,
    formMixin,
    withdrawWarningMixin,
  ],
  components: {
    alertBox,
    availableBalance,
    withdrawConfirm,
  },
  validations() {
    return {
      fields: {
        amount: validators.depositAmountCoinbase(this.minWithdrawal, this.maxWithdrawal),
      },
    };
  },
  created() {
    this.checkWithdrawCoinbase();
  },
  data() {
    return {
      countries: [],
      error: '',
      showConfirmation: false,
      fields: {
        amount: '',
      },
    };
  },
  computed: {
    ...mapState('wallet', ['withdrawCoinbase']),
    availableBalance() {
      return (this.withdrawCoinbase && this.withdrawCoinbase.availableFundsString) ? this.withdrawCoinbase.availableFundsString : '$0.00';
    },
    restrictedFunds() {
      return (this.withdrawCoinbase && this.withdrawCoinbase.restrictedFundsString) ? this.withdrawCoinbase.restrictedFundsString : '';
    },
    minWithdrawal() {
      return (this.maxWithdrawal > 0) ? 1 : 0;
    },
    maxWithdrawal() {
      return this.withdrawCoinbase ? roundDown(this.withdrawCoinbase.availableFunds) : 0;
    },
    isWithdrawalDisabled() {
      return Number(this.fields.amount || 0) === 0;
    },
    isAmountFieldDisabled() {
      return this.minWithdrawal < 1 || this.maxWithdrawal < 1;
    },
    errorMessage() {
      return this.error || this.withdrawCoinbase.errorMessage;
    },
    hasErrorMessage() {
      return this.error || !!this.withdrawCoinbase.errorMessage;
    },
  },
  methods: {
    ...mapActions('user', ['getVerifyID']),
    ...mapActions('wallet', ['getWithdrawCoinbase']),
    onSubmit() {
      this.showConfirmation = true;
    },
    onSuccess() {
      this.fields.amount = '';
      this.showConfirmation = false;
      // this.$nextTick(() => { this.$v.$reset(); });
      this.checkWithdrawCoinbase();
      this.$emit('success');
    },
    onEdit() {
      this.showConfirmation = false;
    },
    checkWithdrawCoinbase() {
      this.getWithdrawCoinbase()
        .then((data) => {
          this.checkDocumentUploadFlags(data);
          this.checkWarningFlags(data);
          this.isComponentReady = true;
        })
        .catch((error) => {
          this.isComponentReady = true;
          this.error = get(error, 'response.data.message', '');
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/withdraw-funds-coinbase/withdraw-funds-coinbase.js